export const response_auth_login = {
  description: 'Datos de autenticación',
  schema: {
    type: 'object',
    properties: {
      access_token: { type: 'string' },
      refresh_token: { type: 'string' },
      expires_in: { type: 'number' },
      refresh_expires_in: { type: 'number' },
      user: {
        type: 'object',
        properties: {
          id: { type: 'string', format: 'uuid' },
          username: { type: 'string' },
          empresa_id: { type: 'string', format: 'uuid' },
        },
      },
    },
  },
};

export const response_auth_register = {
  description: 'Empresa y usuario creado exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          empresa_id: { type: 'string', format: 'uuid' },
          usuario_id: { type: 'string', format: 'uuid' },
          razon_social: { type: 'string' },
          ruc: { type: 'string' },
        },
      },
    },
  },
};

export const response_auth_logout = {
  description: 'Logout exitoso',
  schema: {
    properties: {
      message: { type: 'string', example: 'Logout exitoso' },
    },
  },
};
